import { type FormAnswerMembers } from './insightsTypes'
import { type NumericBucketField } from './numericBucketing'

export const numericBucketField = (members: FormAnswerMembers): NumericBucketField | null =>
  members.bucketStem == null ? null : { stem: members.bucketStem, rawMember: members.valueNumeric }
